import { Dispatch, Middleware, MiddlewareAPI, Action } from 'redux'
import { MESSAGE_TYPES } from 'types/globalMessaging'
import { showMessage } from 'utils/actions/globalMessaging'
import { IShipperRate, IShipperRatesState } from 'apps/rms/types/shipperRates'
import {
  CREATE_SHIPPER_RATES_ACTIONS,
  BULK_CREATE_SHIPPER_RATES_ACTIONS,
  UPDATE_SHIPPER_RATES_ACTIONS,
  BULK_UPDATE_SHIPPER_RATES_ACTIONS,
  fetchShipperRates,
  closeEditShipperRateModal,
} from 'apps/rms/utils/actions/shipperRates'

const BULK_SHIPPER_RATES_SUCCESS_ACTIONS = [
  BULK_CREATE_SHIPPER_RATES_ACTIONS.BULK_CREATE_SHIPPER_RATES_SUCCESS,
  BULK_UPDATE_SHIPPER_RATES_ACTIONS.BULK_UPDATE_SHIPPER_RATES_SUCCESS,
]

interface EditShipperRatesAction extends Action<string> {
  payload: IShipperRate
}

export const shipperRates: Middleware = (store: MiddlewareAPI) => (next: Dispatch) => (
  action: EditShipperRatesAction
) => {
  const {
    shipperRates: { params },
  }: { shipperRates: IShipperRatesState } = store.getState()

  if (action.type === CREATE_SHIPPER_RATES_ACTIONS.CREATE_SHIPPER_RATES_SUCCESS) {
    store.dispatch(closeEditShipperRateModal())
    store.dispatch(fetchShipperRates(params))
    store.dispatch(
      showMessage('Shipper rate(s) successfully added.', {
        type: MESSAGE_TYPES.info,
        closeDelay: 5000,
      })
    )
  }
  if (action.type === UPDATE_SHIPPER_RATES_ACTIONS.UPDATE_SHIPPER_RATES_SUCCESS) {
    store.dispatch(closeEditShipperRateModal())
    store.dispatch(fetchShipperRates(params))
    store.dispatch(
      showMessage('Shipper rate(s) successfully updated.', {
        type: MESSAGE_TYPES.info,
        closeDelay: 5000,
      })
    )
  }
  if (BULK_SHIPPER_RATES_SUCCESS_ACTIONS.includes(action.type)) {
    store.dispatch(closeEditShipperRateModal())
    store.dispatch(fetchShipperRates(params))
    store.dispatch(
      showMessage(
        'File has been uploaded for processing! Results will be emailed when completed.',
        {
          type: MESSAGE_TYPES.info,
          closeDelay: 8000,
        }
      )
    )
  }

  return next(action)
}
